export default {"src":"/_next/static/media/scheduled_maintenance.322e5c5a.svg","height":219,"width":351,"blurWidth":0,"blurHeight":0};